var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('input',_vm._g(_vm._b({staticClass:"checkbox-input absolute opacity-0",attrs:{"type":"checkbox"}},'input',_vm.$attrs,false),_vm.$listeners)),_c('label',{staticClass:"checkbox-label cursor-pointer select-none relative block pl-12",class:{
      'opacity-50 pointer-events-none': _vm.$attrs.disabled,
    },attrs:{"for":_vm.$attrs.id}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }